export enum CONCILIATION_PERMISSIONS {
  CONCILIATION_VIEW = 'REPORT_CONCILIATIONVIEW',
  CONCILIATION_WRITE = 'REPORT_CONCILIATIONWRITE',
}
